import Error from "./Error";
import Header from "./Header";
import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";

function ErrorFullScreen({ error }: { error?: any }): JSX.Element {
  const { instance } = useMsal();

  useEffect(() => {
    // If error is related to authentication (user cancelled, not logged in), redirect to login
    if (
      error &&
      (error.errorCode === "user_cancelled" ||
        error.errorCode === "login_required" ||
        error.errorCode === "access_denied" ||
        error.message?.toLowerCase().includes("user has cancelled") ||
        error.message?.toLowerCase().includes("user cancelled"))
    ) {
      instance.loginRedirect();
    }
  }, [error, instance]);

  return (
    <>
      <Header showMenuIcon={false} />
      <div className="flex h-screen w-screen items-center justify-center">
        <Error message="Error while trying to authenticate. Please try again." />
      </div>
    </>
  );
}

export default ErrorFullScreen;
